// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const MANAGE_PROFILE_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.ManageProfile,
        order: 10,
        conditions: [HelpConditional.Users],
        bookmark: 'manage-account',
        title: helpTitle('manage-account'),
        body: '<p>Click your avatar (the circle with your initials) in the header to open your '
            + 'profile menu. From there you can:</p>'
            + '<ul>'
            + '|condition:LinkedAccounts|<li>Manage your |term:plural|</li>'
            + '|endcondition:LinkedAccounts|'
            + '<li>Update your personal information</li>'
            + '<li>Manage your notification settings</li><li>Change your password</li>'
            + '|condition:NotRedirect|<li>Manage your saved payment methods</li>'
            + '|endcondition:NotRedirect|'
            + '<li>View your payment history</li>'
            + '|condition:ScheduledPayments|<li>Manage your schedules</li>'
            + '|endcondition:ScheduledPayments|'
            + '<li>Sign out</li></ul>'
    })
];
